import Link from 'next/link';
import { use } from 'react';

import { TradingLeaderboardTier } from '@flipster/apis/v2/trading-leaderboards/types';
import { Styles, css } from '@flipster/styled-system/css';
import { center, flex, hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { LeaderboardContext } from '../bunja';
import { tierInfos } from '../shared/constants';
import { LeaderboardTierIcon } from '../shared/tier-icon';

interface LeagueTabsProps {
  css: Styles;
}
export const TierTabs = ({ css: cssProps }: LeagueTabsProps) => {
  const { interval, tier: currentTier } = use(LeaderboardContext);
  return (
    <div className={css(hstack.raw({ gap: 4, overflowX: 'scroll', tabletDown: { w: '100%' } }), cssProps)}>
      {(Object.keys(tierInfos) as TradingLeaderboardTier[]).map((tier) => (
        <Link
          className={css({ tabletDown: { flex: 1 } })}
          key={tier}
          href={`?interval=${interval}&tier=${tier}`}
          onClick={() =>
            segment.track(TradingLeaderboardEvent.LeaderboardTierClick, {
              interval,
              tier: tier,
            })
          }
        >
          <TierTab tier={tier} selected={tier === currentTier} />
        </Link>
      ))}
    </div>
  );
};

interface TierTabProps {
  tier: TradingLeaderboardTier;
  selected?: boolean;
}
const TierTab = ({ tier, selected }: TierTabProps) => {
  return (
    <div
      className={css(
        flex.raw({
          w: '100%',
          minW: 96,
          justify: 'center',
          gap: 2,
          py: 8,
          px: 16,
          rounded: 8,
          color: 'content.default.level-1',
          _hover: {
            bg: 'background.accent.secondary.tint.hover',
          },
        }),
        selected && {
          bg: 'background.default.level-3',
          color: 'content.default.level-5',
        },
      )}
    >
      <div className={center({ flexDirection: 'column', gap: 4 })}>
        <LeaderboardTierIcon tier={tier} size={24} />
        <p className={css({ textStyle: 'Text/M/Strong' })}>{tierInfos[tier].label}</p>
      </div>
    </div>
  );
};
